"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ControlSidebar {
    constructor(container) {
        this.baseClass = 'c-openstreetmap';
        this.container = container;
        this.container && this.init();
    }
    init() {
        this.expandSidebar();
        this.observeSizeClasses();
    }
    observeSizeClasses() {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                var _a;
                if (mutation.type === 'attributes' &&
                    mutation.attributeName === 'class' &&
                    mutation.oldValue !== this.container.className &&
                    !this.container.classList.contains('is-expanded') &&
                    !this.container.classList.contains(`${this.baseClass}--size-sm`)) {
                    const previousClasses = (_a = mutation.oldValue) === null || _a === void 0 ? void 0 : _a.split(' ');
                    const currentClasses = this.container.className.split(' ');
                    const removedClasses = previousClasses === null || previousClasses === void 0 ? void 0 : previousClasses.filter(className => !currentClasses.includes(className));
                    if (removedClasses && removedClasses.includes(`${this.baseClass}--size-sm`)) {
                        this.expandSidebar();
                    }
                }
            });
        });
        const config = {
            attributes: true,
            attributeFilter: ['class'],
            attributeOldValue: true,
            subtree: false,
        };
        observer.observe(this.container, config);
    }
    expandSidebar() {
        if (!this.container.classList.contains(`${this.baseClass}--size-sm`)) {
            this.container.classList.add('is-expanded');
        }
    }
}
exports.default = ControlSidebar;
